export default {
  chat: () => import("/app/layouts/chat.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  error: () => import("/app/layouts/error.vue").then(m => m.default || m),
  "error-page-layout": () => import("/app/layouts/errorPageLayout.vue").then(m => m.default || m),
  guest: () => import("/app/layouts/guest.vue").then(m => m.default || m),
  login: () => import("/app/layouts/login.vue").then(m => m.default || m)
}